import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeasure = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "#697586",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-ruler-measure",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 12v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 5h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 3v4" })
	]
});
export default SvgMeasure;
